@if (open) {
    <ul role="menu" [id]="listId" appList @Grow>
        <li class="section-header" aria-hidden="true">
            {{ 'how-can-we-help' | translate }}
        </li>
        @if (canShowCompanyAdminSupport) {
            <li role="none">
                <button class="menu-item tw-w-full" (click)="openCompanyAdminSupportPopup()" appListItem role="menuitem">
                    <app-icon name="chat-warning" class="tw-size-5" />
                    <span class="menu-item-text">{{ 'v3-global-help-admin-support' | translate }}</span>
                </button>
            </li>
        }
        <li role="none">
            <a class="menu-item" target="_blank" href="https://help.socialtalent.com/stpkb/" (click)="close()" appListItem role="menuitem">
                <app-icon name="help-centre" class="tw-size-5" />
                <span class="menu-item-text">{{ 'v3-global-help-st-support' | translate }}</span>
            </a>
        </li>
    </ul>
}
